import styled from 'styled-components';
import { Dialog } from '@material-ui/core';

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    padding: ${({ theme }) => theme.spacing * 4}px;
`;

export const StyledDialog = styled(Dialog)`
    && {
        .MuiDialog-paperFullWidth {
            width: auto;
        }
        .MuiDialog-paperWidthSm {
            max-width: 100%;
        }
    }
`;
